<div class="flex items-center justify-center w-full max-w-screen-sm">
    <hr class="flex-grow border-border" />
    <span class="px-4 text-neutral-800">{{ text }}</span>
    <hr class="flex-grow border-border" />
</div>